let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("37xVM")).then(() => parcelRequire('7NZoR'));